import React from 'react';

import {
  ReportAttendanceToolbar,
  ReportAttendanceList,
} from 'views/Reports/Attendance/components';
import { useStyles } from './styles';
import ReportData, { AdminReportType } from 'services/dataService/ReportData';
import ATTENDANCEReportJSON from 'constants/JSONConstants/attendance-report-table-columns';
import { useTranslation } from 'react-i18next';
import { CustomFieldsData } from 'services/dataService';


export default () => {
  const classes = useStyles();
  const [fields, setFields] = React.useState([]);
  const { t } = useTranslation(['tables']);
  const [loading, setLoading] = React.useState(true);

  const loadFields = async () => {
    try {      
      const { data: reportFields } = await ReportData.getReportFields(
        AdminReportType.ATTENDANCE
      );
      
      const { data: customFields } = await CustomFieldsData.getCustomFields();
      const customfieldsArray = JSON.parse(customFields?.custom_fields || '[]');

      let reportData = [];
      let serverText = false;

      if (reportFields?.table_titles?.length) {
        reportData = reportFields?.table_titles;
      } else {
        reportData = ATTENDANCEReportJSON;
        reportData = reportData.concat(
          customfieldsArray?.map((field) => {
            return {
              title: field?.fieldName,
              field: field?.fieldName,
              type: field?.type,
              selected: false,
            };
          }) || []
        );
      }
      
      setFields(
        reportData.map(({ title, field, selected, type }) => {          
          return {
            title: serverText ? title : t(title),
            field,
            hidden: !selected,
            type,
          };     
      })
      );
    } catch (error) {
      setFields(
        ATTENDANCEReportJSON.map(({ title, field, selected, type }) => {
          return { title: t(title), field, hidden: !selected, type };
        })
      );
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    loadFields();
  }, []);


  return (
    <div className={classes.root}>
      {!loading && (
        <>
          <ReportAttendanceToolbar
            fields={fields}
            onSave={async (selectedList) => {
              await ReportData.updateFields({
                type: AdminReportType.ATTENDANCE,
                table_titles: selectedList,
              });

              loadFields();
            }}
          />
          <div className={classes.content}>
            <ReportAttendanceList fields={fields} />
          </div>
        </>
      )}
    </div>
  );
};
